module.exports = __webpack_public_path__ + "static/media/gamesPlayed_5000_10000.e9e6356c.png";